export default "__VITE_PUBLIC_ASSET__fccf0a1d__"